import { Importer } from 'dashboard/models/importer';
import Action from 'lib/interfaces/Action';

interface ImporterPayload {
  importer: Importer;
}

export type ImporterActions = Action<ImporterActionType.SaveImporter, ImporterPayload>;

export enum ImporterActionType {
  SaveImporter = 'importer/SAVE_IMPORTER',
}

export function saveImporter(importer: Importer) {
  return {
    payload: {
      importer,
    },
    type: ImporterActionType.SaveImporter,
  };
}
